var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6679 1C14.6679 0.585786 15.0036 0.25 15.4179 0.25H21C21.4142 0.25 21.75 0.585786 21.75 1V6.54583C21.75 6.96005 21.4142 7.29583 21 7.29583C20.5858 7.29583 20.25 6.96005 20.25 6.54583V2.80286L14.1142 8.90129C13.6452 9.36744 13.241 9.76923 12.8739 10.0477C12.4804 10.3462 12.0432 10.572 11.505 10.572C10.9668 10.5719 10.5297 10.346 10.1362 10.0474C9.76923 9.76884 9.36512 9.36697 8.89629 8.90072L8.62203 8.62801C8.10787 8.11675 7.77452 7.78751 7.49695 7.57686C7.23672 7.37937 7.11506 7.35734 7.03449 7.35737C6.95393 7.3574 6.83228 7.37952 6.57219 7.5772C6.29478 7.78805 5.96167 8.11753 5.44789 8.62917L1.52922 12.5314C1.23571 12.8237 0.760838 12.8227 0.468559 12.5292C0.176281 12.2357 0.177276 11.7608 0.470783 11.4686L4.42433 7.53155C4.89326 7.06453 5.29742 6.66202 5.66452 6.383C6.05802 6.08391 6.49535 5.85756 7.03395 5.85737C7.57254 5.85717 8.01003 6.0832 8.40375 6.38199C8.77105 6.66074 9.1755 7.06296 9.64477 7.52963L9.91903 7.80235C10.4327 8.31316 10.7658 8.64209 11.0431 8.85257C11.3031 9.04989 11.4247 9.07197 11.5052 9.07198C11.5857 9.07199 11.7073 9.04994 11.9673 8.85268C12.2447 8.64226 12.5778 8.31341 13.0916 7.80272L19.1815 1.75H15.4179C15.0036 1.75 14.6679 1.41421 14.6679 1Z",
    fill: "url(#paint0_linear_2296_447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2296_447",
    x1: 0.25,
    y1: 6.5,
    x2: 21.75,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FA95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.72dcd1652f9aad38925a8461ca080147.svg";
export { ForwardRef as ReactComponent };